import qs from "query-string";

import { _CFG } from "../config";

export const Open = (url) => {
    if (!url) {
        return;
    }
    let isMobile = false;
    if (window.location.search) {
        const parsedQs = qs.parse(window.location.search);
        isMobile = !!parsedQs.device;
    }

    if (isMobile) {
        window.location.href = `${_CFG.appSchema}open?url=${encodeURIComponent(url)}`;
    } else {
        window.location.href = `#${url}`;
    }
};

export const OpenMenu = (url) => {
    if (!url) {
        return;
    }

    let isMobile = false;
    if (window.location.search) {
        const parsedQs = qs.parse(window.location.search);
        isMobile = !!parsedQs.device;
    }

    const { hash } = window.location;
    const dest = `#${url}`;
    if (hash === dest) {
        return;
    }

    if (isMobile) {
        window.location.href = `${_CFG.appSchema}open?url=${encodeURIComponent(url)}`;
    } else {
        window.location.href = `#${url}`;
    }
};

export const goBack = () => {
    let isMobile = false;
    if (window.location.search) {
        const parsedQs = qs.parse(window.location.search);
        isMobile = !!parsedQs.device;
    }

    if (isMobile) {
        window.location.href = `${_CFG.appSchema}finish`;
    } else {
        window.history.back();
    }
};

export default {
    Open,
    OpenMenu,
    goBack,
};
